(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const guidanceParams = new URLSearchParams(location.search);
  if (guidanceParams.get('inquiry') === 'help-choose') {
    const form = document.getElementById('ContactForm');
    if (form) {
      const artwork = form.querySelector('#ContactForm-artwork');
      if (artwork && !artwork.value) artwork.value = (guidanceParams.get('artwork') || '').slice(0, 500);
      const source = guidanceParams.get('product') || '';
      try {
        const url = new URL(source, location.origin);
        if (url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[a-z0-9-]+$/.test(url.pathname)) {
          const input = form.querySelector('#ContactForm-artwork-url');
          input.value = url.href;
          input.disabled = false;
        }
      } catch (_) {}
      form.querySelector('#ContactForm-inquiry').disabled = false;
      form.querySelector('[data-mkp-guidance-intro]').hidden = false;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkp-buying-help"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('ArtworkHelpForm');
    if (!form) return;
    const params = new URLSearchParams(location.search);
    const setEmpty = (id, value) => {
      const field = document.getElementById(id);
      if (field && !field.value && value) field.value = value.slice(0, field.maxLength > 0 ? field.maxLength : 5000);
    };
    setEmpty('ArtworkHelpArtwork', params.get('artwork'));
    setEmpty('ArtworkHelpPreference', [params.get('size'), params.get('frame')].filter(Boolean).join(' / '));
    const product = params.get('product');
    if (product) {
      try {
        const url = new URL(product, location.origin);
        if (url.origin === location.origin && url.pathname.startsWith('/products/')) setEmpty('ArtworkHelpProduct', url.href);
      } catch (_) {}
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkp-print-size-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mkp-print-size-guide')) {
    customElements.define('mkp-print-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.artwork = this.querySelector('[data-guide-artwork]');
        this.furniture = this.querySelector('[data-guide-furniture]');
        this.width = this.querySelector('[data-guide-width]');
        this.artwork.addEventListener('change', () => this.update());
        this.furniture.addEventListener('change', () => { this.width.value = this.furniture.selectedOptions[0].dataset.width; this.update(); });
        this.width.addEventListener('input', () => this.update());
        this.update();
      }
      update() {
        const width = Number(this.width.value);
        if (!this.width.checkValidity() || !width) return;
        const option = this.artwork.selectedOptions[0];
        if (!option) return;
        const x = (144 - width) / 2;
        for (const scene of this.querySelectorAll('[data-guide-scene]')) {
          const ow = Number(scene.dataset.outerWidth), oh = Number(scene.dataset.outerHeight);
          const pw = Number(scene.dataset.printWidth), ph = Number(scene.dataset.printHeight), face = Number(scene.dataset.frameFace);
          const setRect = (selector, left, top, w, h) => {
            const el = scene.querySelector(selector);
            for (const [key, value] of Object.entries({x:left,y:top,width:w,height:h})) el.setAttribute(key,value);
          };
          setRect('[data-guide-outer]', (144-ow)/2, 61-oh, ow, oh);
          setRect('[data-guide-mat]', (144-ow)/2+face, 61-oh+face, ow-face*2, oh-face*2);
          setRect('[data-guide-photo]', (144-pw)/2, 61-oh+(oh-ph)/2, pw, ph);
          scene.querySelector('[data-guide-photo]').setAttribute('href',option.dataset.image);
          const furniture = scene.querySelector('[data-guide-furniture-shape]');
          if (this.furniture.value === 'console') furniture.innerHTML = `<path d="M${x} 71h${width}v4H${x}z" fill="#907154"/><path d="M${x+3} 75v23M${x+width-3} 75v23" stroke="#68523e" stroke-width="2"/>`;
          else if (this.furniture.value === 'bed') furniture.innerHTML = `<rect x="${x}" y="68" width="${width}" height="27" rx="2" fill="#b4a18e"/><rect x="${x+2}" y="79" width="${width-4}" height="18" fill="#faf8f1"/><rect x="${x+5}" y="76" width="${(width-14)/2}" height="7" rx="2" fill="#fff"/><rect x="${x+width/2+2}" y="76" width="${(width-14)/2}" height="7" rx="2" fill="#fff"/>`;
          else furniture.innerHTML = `<rect x="${x}" y="70" width="${width}" height="23" rx="3" fill="#c3cbc9"/><rect x="${x+1}" y="79" width="${width-2}" height="16" rx="2" fill="#b3bfbb"/><path d="M${x+width/3} 71v18M${x+width*2/3} 71v18" stroke="#a2b0aa" stroke-width=".5"/><path d="M${x+5} 95v4M${x+width-5} 95v4" stroke="#5d5953" stroke-width="2"/>`;
        }
        this.querySelector('[data-guide-product]').href = option.value;
        const help = new URL('/pages/get-help-choosing',location.origin);
        help.searchParams.set('artwork',option.dataset.title);
        help.searchParams.set('product',option.value);
        this.querySelector('[data-guide-help]').href = help.pathname+help.search;
        this.querySelector('[data-guide-status]').textContent = `${option.dataset.title} · ${this.furniture.selectedOptions[0].textContent} · ${width}″`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
